import {
  UsersitePlansGetRegionTypePayload,
  UsersitePlansGetTagTypePayload,
} from '~/models/schema';

export const ACTION_TYPE = {
  SET_SP_DRAWER_OPEN: 'setSPDrawerOpen',
  SET_SEARCH_DRAWER_OPEN: 'setSearchDrawerOpen',
  SET_PROFILE_MENU_EL: 'setProfileMenuEl',
  SET_SEARCH_CHOICE: 'setSearchChoice',
} as const;
type ActionType = typeof ACTION_TYPE[keyof typeof ACTION_TYPE];
type Payload = Partial<State>;
export interface Action {
  type: ActionType;
  payload: Payload;
}
export interface State {
  spDrawerOpen: boolean;
  searchDrawerOpen: boolean;
  loadedSearchChoice: boolean;
  profileMenuEl: Element | null;
  tags: UsersitePlansGetTagTypePayload[];
  regions: UsersitePlansGetRegionTypePayload[];
}
export const initialState: State = {
  spDrawerOpen: false,
  searchDrawerOpen: false,
  loadedSearchChoice: false,
  profileMenuEl: null,
  tags: [],
  regions: [],
};

const setStateWithDefaultValue = (
  payload: Payload,
  prevState: State,
): State => ({
  ...prevState,
  ...payload,
});

export const reducer = (state, { type, payload }) => {
  switch (type as ActionType) {
    case ACTION_TYPE.SET_SP_DRAWER_OPEN:
      return setStateWithDefaultValue(payload, state);
    case ACTION_TYPE.SET_SEARCH_DRAWER_OPEN:
      return setStateWithDefaultValue(payload, state);
    case ACTION_TYPE.SET_PROFILE_MENU_EL:
      return setStateWithDefaultValue(payload, state);
    case ACTION_TYPE.SET_SEARCH_CHOICE:
      return setStateWithDefaultValue(payload, state);

    default:
      return state;
  }
};
